// Meta Pixel (Facebook) — načíta sa LEN ak používateľ udelil súhlas s marketingovými cookies.
// GDPR: žiadny tracking pred consent.

const META_PIXEL_ID = '1450425560220547';
const STORAGE_KEY = 'cookie_consent';
const COOKIE_VERSION = 'v1.0';

let initialized = false;

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

interface CookiePrefs {
  version: string;
  necessary: true;
  analytics: boolean;
  marketing: boolean;
}

export function hasMarketingConsent(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const p = JSON.parse(raw) as CookiePrefs;
    return p.version === COOKIE_VERSION && p.marketing === true;
  } catch {
    return false;
  }
}

/** Načíta Meta Pixel script a spustí PageView. Bezpečné volať opakovane. */
export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return;
  if (!hasMarketingConsent()) return;

  // Štandardný Meta Pixel base code (cez closure aby sme nešpinili globál)
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
  initialized = true;
}

/** Track PageView pri SPA navigácii — len ak je marketing consent a pixel inicializovaný. */
export function trackPageView(): void {
  if (!hasMarketingConsent()) return;
  if (!initialized) {
    // Prvé volanie po consente — inicializuj (pošle PageView samo)
    initMetaPixel();
    return;
  }
  window.fbq?.('track', 'PageView');
}

/**
 * Pošli štandardný (alebo custom) Meta event. Tiché no-op ak nie je marketing consent.
 * Príklad: trackEvent('Lead', { content_name: 'waitlist' })
 */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!hasMarketingConsent()) return;
  if (!initialized) initMetaPixel();
  if (!initialized) return; // initMetaPixel skip ak medzitým consent odvolaný
  window.fbq?.('track', name, params || {});
}
